export default __webpack_public_path__ + "static/media/msteams.5dc1e65d.webp";